import React from "react";
import {
  ScatterChart,
  CartesianGrid,
  XAxis,
  YAxis,
  ZAxis,
  Tooltip,
  Scatter,
} from "recharts";
import { ChartStrategy } from "./ChartStrategy";
import { DYCHARTCOLORS } from "../../../../core/constants/chartStyles";

export class ScatterChartStrategy extends ChartStrategy {
  render() {
    const isNumberXAxis = !isNaN(
      this.props.normalizedData[0]?.[this.props.xAxis],
    );

    return (
      <ScatterChart {...this.commonProps}>
        <CartesianGrid stroke={this.props.gridColor} strokeDasharray="3 3" />
        <XAxis
          type={isNumberXAxis ? "number" : "category"}
          dataKey={this.props.xAxis}
          {...this.axisProps}
        />
        <YAxis type="number" dataKey={this.props.yAxis} {...this.axisProps} />
        {this.props.chartType === "bubble" && (
          <ZAxis dataKey={this.props.yAxis} range={[50, 500]} />
        )}
        <Tooltip
          cursor={{ strokeDasharray: "3 3" }}
          content={this.props.scatterTooltip}
        />
        <Scatter
          name={this.props.title}
          data={this.props.normalizedData}
          fill={DYCHARTCOLORS[0]}
          shape="circle"
        />
      </ScatterChart>
    );
  }
}
